import { authRequest } from "./helper";

export const getUploadedFiles = (payload: any) =>
  authRequest({
    method: "POST",
    url: "/files/",
    data: payload,
  })
    .then(({ data }) => data)
    .catch((error) => console.error("Error: ", error));

export const getUploadFileStatus = (etag: string) =>
  authRequest({
    method: "GET",
    url: `/file-status/${etag}`,
  })
    .then(({ data }) => data)
    .catch((error) => console.error("Error: ", error));

export const getUploadOverview = (payload: any) =>
  authRequest({
    method: "POST",
    url: "/fileoverview",
    data: payload,
  })
    .then(({ data }) => data)
    .catch((error) => console.error("Error: ", error));

export const getS3PresignedURL = (payload: any) =>
  authRequest({
    method: "POST",
    url: `/file-upload-presigned-url`,
    data: payload,
  })
    .then(({ data }) => data)
    .catch((error) => console.error("Error: ", error));

export const getEnqueuedFiles = () =>
  authRequest({
    method: "GET",
    url: "/filequeue",
  })
    .then(({ data }) => data)
    .catch((error) => console.error("Error: ", error));

export const proceedUpload = (payload: any) =>
  authRequest({
    method: "POST",
    url: "/etltrigger",
    data: payload,
  })
    .then(({ data }) => data)
    .catch((error) => console.error("Error: ", error));
